import { Pipe, PipeTransform } from '@angular/core';
import { GlobalRole } from '@thehubz/shared/user-access';
import { UserAccessService } from './user-access.service';

@Pipe({
  name: 'hasGlobalRole',
})
export class HasGlobalRolePipe implements PipeTransform {
  constructor(private readonly userAccessService: UserAccessService) {}

  transform(role: GlobalRole): boolean {
    return this.userAccessService.hasRole(role);
  }
}
